<template>
	<tr class="customtableloading" >
		<td class="text-center pageoader" :colspan="colspan" >
			<div class="hm-spinner"></div>
		</td>
	</tr>
</template>

<script>
export default {
	name: 'app-table-loader',
	data() {
		return { }
	},
	props:{
		'colspan' : {
		    default: '',
		},
		'page' : {
		    default: '',
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/table_loader.vue